import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import {
  NavItemContainer,
  NavIcon,
  NavLabel,
  NavStatusIndicator,
  RouteLink,
} from "./styles.js";

const { string } = PropTypes;

const NavItem = ({ navItem, closeNavBar }) => {
  const [isActive, setIsActive] = useState(false);
  let { pathname } = useLocation();

  const { id, iconSrc, label, url } = navItem;

  const checkPath = () => (id === "dashboard" ? `/Vendor` : `/Vendor/${id}`);

  useEffect(() => {
    if (pathname === checkPath()) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [pathname]);

  return (
    <RouteLink
      to={`/${url}`}
      style={{ textDecoration: "none", color: "white" }}
    >
      <NavItemContainer isActive={isActive} onClick={closeNavBar}>
        <NavStatusIndicator isActive={isActive} />
        <NavIcon>
          <img
            src={iconSrc}
            alt={`${id} SVG Icon`}
            style={{
              width: "1rem",
              height: "1rem",
              display: "flex",
              alignSelf: "center",
              lineHeight: "1.1rem",
            }}
          />
        </NavIcon>
        <NavLabel>{label}</NavLabel>
      </NavItemContainer>
    </RouteLink>
  );
};

NavItem.propTypes = {
  navItem: PropTypes.shape({
    id: string.isRequired,
    iconSrc: string.isRequired,
    label: string.isRequired,
    url: string.isRequired,
  }),
  closeNavBar: PropTypes.func.isRequired,
};

export default NavItem;
